import { render } from "./ParticipantFeedback.vue?vue&type=template&id=3198cd1a&scoped=true&ts=true"
import script from "./ParticipantFeedback.vue?vue&type=script&lang=ts"
export * from "./ParticipantFeedback.vue?vue&type=script&lang=ts"

import "./ParticipantFeedback.vue?vue&type=style&index=0&id=3198cd1a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3198cd1a"]])

export default __exports__